import { animated } from 'react-spring';

import { styled } from '../../hooks/theme';
import { Tokens } from '../../types';

export const Container = styled.div`
  padding: 32px;
  border-radius: 4px;

  background-color: ${props => props.theme.colors.neutral.grey[0]};
  border: ${props => props.theme.colors.neutral.grey[10]};

  transition: background-color 0.1s;
`;
Container.defaultProps = {
  theme: Tokens.eixods,
};

export const HeaderContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    cursor: pointer;
  }

  img:hover {
    opacity: 0.5;
  }
`;

export const HeaderSeparator = styled.div`
  margin: 16px 0;
  border-bottom: 1px solid ${props => props.theme.colors.neutral.grey[10]};
`;
HeaderSeparator.defaultProps = {
  theme: Tokens.eixods,
};

export const ShownContainer = styled.div``;

export const HiddenContainer = styled(animated.div)`
  overflow: hidden;
`;
